/**
* Component     : Configuration
* Author        : Boston Byte LLC
* Creation Date : 3rd August 2017
*/

import { environment as env, cineburo_environment as cineburoEnv } from '../../environments/environment';
import { environment as envDev, cineburo_environment as cineburoEnvDev } from '../../environments/environment.dev';
import { environment as envStage, cineburo_environment as cineburoEnvStage } from '../../environments/environment.stage';
import { environment as envUat, ent_environment as entenvUat, cineburo_environment as cineburoEnvUat } from '../../environments/environment.uat';
import { environment as envProd, ent_environment as entenvProd , cineburo_environment as cineburoEnvProd } from '../../environments/environment.prod';

class Environment {
  public environment: any = {};

  constructor(private window: Window) {
    this.setEnvironmentDetails();
  }

  setEnvironmentDetails() {
    const hostName = this.window.location.hostname;
    let companyName = 'theProdProcess';
    this.environment['COMPANY_NAME'] = companyName;
    if (hostName.includes('cineburo.com')) {
      companyName = 'cineburo';
      const devAdmin = hostName.match(/^devportal\.cineburo\.com/);
      const stageAdmin = hostName.match(/^stageportal\.cineburo\.com/);
      const uatAdmin = hostName.match(/^uatportal\.cineburo\.com/);
      const prodAdmin = hostName.match(/^portal\.cineburo\.com/);
      const localAdmin = hostName.match(/^localhost\:[0-9]+/);
      this.environment = cineburoEnvDev;
      if (devAdmin !== undefined && devAdmin != null && devAdmin.length > 0) {
        this.environment = cineburoEnvDev;
      } else if (stageAdmin !== undefined && stageAdmin != null && stageAdmin.length > 0) {
        this.environment = cineburoEnvStage;
      } else if (uatAdmin !== undefined && uatAdmin != null && uatAdmin.length > 0) {
        this.environment = cineburoEnvUat;
      } else if (prodAdmin !== undefined && prodAdmin != null && prodAdmin.length > 0) {
        this.environment = cineburoEnvProd;
      } else if (localAdmin != null && localAdmin.length > 0 || hostName === 'localhost' || hostName === '192.168.15.213') {
        this.environment = cineburoEnv;
      }
      this.environment['LOGO_TRANSPARENT_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/CineburoLogoTransparent.png';
      this.environment['LOGO_BLACK_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/CineburoLogoBlack.png';
      this.environment['COMPANY_ID'] = '5c93cbafb1fe4612f820b05e';
    } 
    else if(hostName.includes('thelift.mx')){
       companyName = 'thelift';
      this.environment['COMPANY_NAME'] = companyName;
      const devAdmin = hostName.match(/^deventportal\.thelift\.mx/);
      const stageAdmin = hostName.match(/^stageentportal\.thelift\.mx/);
      const uatAdmin = hostName.match(/^uatentportal\.thelift\.mx/);
      const prodAdmin = hostName.match(/^entportal\.thelift\.mx/);
      const localAdmin = hostName.match(/^localhost\:[0-9]+/);
      this.environment = envDev;
      if (devAdmin !== undefined && devAdmin != null && devAdmin.length > 0) {
        this.environment = envDev;
      } else if (stageAdmin !== undefined && stageAdmin != null && stageAdmin.length > 0) {
        this.environment = envStage;
      } else if (uatAdmin !== undefined && uatAdmin != null && uatAdmin.length > 0) {
        this.environment = entenvUat;
      } else if (prodAdmin !== undefined && prodAdmin != null && prodAdmin.length > 0) {
        this.environment = entenvProd;
      } else if (localAdmin != null && localAdmin.length > 0 || hostName === 'localhost' || hostName === '192.168.15.213') {
        this.environment = entenvUat;
      }
    this.environment['LOGO_TRANSPARENT_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/LiftLogoTransparent.png';
    this.environment['LOGO_BLACK_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/LiftLogoBlack.png';
    this.environment['COMPANY_ID'] = '5b1a7f7c514b1ec6ddb069be';
    }
    else {
      const devAdmin = hostName.match(/^devportal\.thelift\.mx/);
      const stageAdmin = hostName.match(/^stageportal\.thelift\.mx/);
      const uatAdmin = hostName.match(/^uatportal\.theprodprocess\.com/);
      const prodAdmin = hostName.match(/^portal\.theprodprocess\.com/);
      const localAdmin = hostName.match(/^localhost\:[0-9]+/);
      this.environment = envDev;
      if (devAdmin !== undefined && devAdmin != null && devAdmin.length > 0) {
        this.environment = envDev;
      } else if (stageAdmin !== undefined && stageAdmin != null && stageAdmin.length > 0) {
        this.environment = envStage;
      } else if (uatAdmin !== undefined && uatAdmin != null && uatAdmin.length > 0) {
        this.environment = envUat;
      } else if (prodAdmin !== undefined && prodAdmin != null && prodAdmin.length > 0) {
        this.environment = envProd;
      } else if (localAdmin != null && localAdmin.length > 0 || hostName === 'localhost' || hostName === '192.168.15.213') {
        this.environment = envUat;
      }
      this.environment['LOGO_TRANSPARENT_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/ProdProcessLogoTransparent.png';
      this.environment['LOGO_BLACK_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/ProdProcessLogoBlack.png';
      this.environment['COMPANY_ID'] = '5b1a7f7c514b1ec6ddb069be';

      this.environment['LIFT_LOGO_TRANSPARENT_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/LiftLogoTransparent.png';
      this.environment['LIFT_LOGO_BLACK_URL'] = 'https://thelift-prod-assets-bucket.s3.amazonaws.com/logo/LiftLogoBlack.png';
    }
    this.environment['COMPANY_NAME'] = companyName;
  }
}




export class Configuration {
  public static ENV = new Environment(window).environment;
  public static MEDIA_ROOT = ['assets/'];
  public static VIDEO_URL = Configuration.MEDIA_ROOT + 'videos/';
  public static IMAGES_URL = Configuration.MEDIA_ROOT + 'images/';
  public static LOGO_TRANSPARENT_IMAGE_URL = Configuration.ENV.LOGO_TRANSPARENT_URL;
  public static LOGO_BLACK_IMAGE_URL = Configuration.ENV.LOGO_BLACK_URL;
  public static API_ENDPOINT = Configuration.ENV.apiUrl;
  public static FRONTEND_URL = Configuration.ENV.frontendUrl;
  public static S3_BUCKET_URL = Configuration.ENV.s3BucketUrl;
  public static PREBID_ENDPOINT = Configuration.ENV.preBidUrl;
  public static COMPANY_NAME = Configuration.ENV.COMPANY_NAME;
  public static COMPANY_ID = Configuration.ENV.COMPANY_ID;
  public static EMAIL_DOMAINS = ['@mac.com', '@me.com', '@icloud.com'];
  public static INVALID_EMAIL_DOMAIN = Configuration.ENV.invalidEmailDomain;
  public static LIFT_BLACK_IMAGE_URL = Configuration.ENV.LIFT_LOGO_BLACK_URL
}


// WEBPACK FOOTER //
// ./src/app/config/configuration.ts